import React from "react";

const AlreadyPlayedScreen = ({ onGoBack, setActivePanel, setAutoShowAlreadyPlayed }) => {
  const [timeLeft, setTimeLeft] = React.useState("");

  React.useEffect(() => {
    const updateTimer = () => {
      const now = new Date();

      // Get logical today in Central Time
      const centralNow = new Date(now.toLocaleString("en-US", { timeZone: "America/Chicago" }));

      // Calculate next midnight Central Time
      const nextMidnight = new Date(centralNow);
      nextMidnight.setHours(24, 0, 0, 0); // Midnight logical tomorrow

      // Difference is pure milliseconds between the two logical dates 
      // (Constructing dates from strings implicitly handles the timezone offsets correctly or use diff)
      // Actually simpler: difference between "now" in UTC and "next midnight CST" in UTC.

      const msUntilMidnight = nextMidnight - centralNow;

      const h = Math.floor(msUntilMidnight / 3600000);
      const m = Math.floor((msUntilMidnight % 3600000) / 60000);
      const s = Math.floor((msUntilMidnight % 60000) / 1000);

      setTimeLeft(`${h}h ${m}m ${s}s`);
    };

    updateTimer();
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "radial-gradient(circle at center, #03715f, #034c39)",
        color: "#e7c17f",
        fontFamily: `'Baskerville', serif`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding: ".5rem",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "2.5rem", marginBottom: ".05rem", }}>
        {timeLeft || "..."} Until Next Daily
      </h1>
      <p style={{ fontSize: "1.6rem", marginBottom: "2rem" }}>
        Come Back and Play Again!
      </p>
      {/* Menu buttons */}
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <button
          onClick={() => {
            setAutoShowAlreadyPlayed && setAutoShowAlreadyPlayed(true); // Auto-show on return
            onGoBack();
            setActivePanel("stats");
          }}
          style={{
            padding: "1rem 2rem",
            background: "linear-gradient(135deg, #002d21, #00372a)",
            color: "#e7c17f",
            borderRadius: "0.5rem",
            cursor: "pointer",
            fontFamily: "Baskerville, serif",
            width: "100%",
            maxWidth: "300px",
            fontWeight: "bold",
            border: "none",
            boxShadow: "none",
            fontSize: "22px",
          }}
        >
          My Stats
        </button>
        <button
          onClick={() => {
            setAutoShowAlreadyPlayed && setAutoShowAlreadyPlayed(true); // Auto-show on return
            onGoBack();
            setActivePanel("leaderboard");
          }}
          style={{
            padding: "1rem 2rem",
            background: "linear-gradient(135deg, #002d21, #00372a)",
            color: "#e7c17f",
            borderRadius: "0.5rem",
            cursor: "pointer",
            fontFamily: "Baskerville, serif",
            width: "100%",
            maxWidth: "300px",
            fontWeight: "bold",
            border: "none",
            boxShadow: "none",
            fontSize: "22px",
          }}
        >
          Leaderboard
        </button>
      </div>
    </div>
  );
};

export default AlreadyPlayedScreen;
